import React, { useState, useEffect } from 'react';
import QRCode from 'qrcode';
import Popup from '../../components/Popup';
import SecondaryButton from '../../components/SecondaryButton';
import { withTheme } from 'styled-components';
import { Content, ColumnWrapper, HeaderWrapper, Link, SubHeader } from './styles';

const SessionSharePopup = ({ onClose, popupIsOpen, codeUrl, copyLink, session, openSessionEditModal, theme }) => {
  const [qrDownloadUrl, setQrDownloadUrl] = useState('');
  const [qrDownloadFilename, setQrDownloadFilename] = useState('');

  useEffect(() => {
    const getQRCode = async () => {
      try {
        const canvas = document.querySelector('#sessionShareCodeCanvas');
        QRCode.toCanvas(canvas, codeUrl, {
          width: 164,
          height: 164,
          margin: 0,
          errorCorrectionLevel: 'Q',
          color: {
            dark: theme.colors.loopsGreen,
            light: theme.colors.transparentHex,
          },
        });

        const dataUrl = await QRCode.toDataURL(codeUrl, {
          width: 1024,
          height: 1024,
          errorCorrectionLevel: 'Q',
          color: {
            dark: theme.colors.black,
            light: theme.colors.white,
          },
        });

        setQrDownloadUrl(dataUrl);
        setQrDownloadFilename(`loops-${codeUrl.split('/').pop()}-qr.png`);
      } catch (err) {
        console.error(err);
      }
    };
    if (popupIsOpen) {
      getQRCode();
    }
  }, [popupIsOpen]);

  const guestContent = (
    <Content>
      {i18n.__(
        session.allow_guests ? 'share_code_modal_guests_body_allowed' : 'share_code_modal_guests_body_not_allowed',
      )}
      <br />
      <Link
        href="#"
        onClick={(event) => {
          event.preventDefault();
          openSessionEditModal();
        }}
      >
        {i18n.__('share_code_modal_guests_change_settings')}
      </Link>
    </Content>
  );

  const contentPanel = (
    <ColumnWrapper>
      <Content>{i18n.__('share_code_modal_body')}</Content>
      <SubHeader>{i18n.__('share_code_modal_guests_header')}</SubHeader>
      {guestContent}
      <HeaderWrapper>
        <ColumnWrapper>
          <SubHeader>{i18n.__('share_code_modal_link')}</SubHeader>
          <Content>
            <a href={codeUrl}>{codeUrl}</a>
          </Content>
          <Content>
            <SecondaryButton onClick={copyLink} text={i18n.__('share_code_modal_copy_button')} />
          </Content>
        </ColumnWrapper>
        <Content>
          <canvas id="sessionShareCodeCanvas" aria-label={i18n.__('share_code_modal_qr_code')} />
          <br />
          <Link href={qrDownloadUrl} download={qrDownloadFilename}>
            {i18n.__('share_code_modal_download_qr_code')}
          </Link>
        </Content>
      </HeaderWrapper>
    </ColumnWrapper>
  );

  return (
    <Popup
      popupIsOpen={popupIsOpen}
      id="sessionSharePopup"
      heading={i18n.__('share_code_modal_title')}
      contentPanel={contentPanel}
      buttonLabel={i18n.__('app_close')}
      width={675}
      onClose={onClose}
      onClick={onClose}
    />
  );
};

export default withTheme(SessionSharePopup);
